
import React, {Component} from 'react';
import { Button, ButtonGroup } from '@material-ui/core';
import { Drawer } from "ui/Drawer";
import CachedIcon from '@material-ui/icons/Cached';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';

export default class ListFilterDrawer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };

    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.setState({
      isOpen: false
    })
  }

  handleFilterReset = () => {
    const { onFilterReset } = this.props;
    this.handleClose();
    onFilterReset();
  };

  render() {
    const { isOpen } = this.state;
    const { loading, buttonGroupProps, context } = this.props;
    return (
      <React.Fragment>
        <ButtonGroup variant="outlined" size={'small'} {...buttonGroupProps}>
          <Button
            onClick={() => this.setState({isOpen: true})}
            tabIndex={-1}
            disabled={loading}
            startIcon={<FilterListIcon />}
          >
            Фильтры
          </Button>
          <Button
            disabled={loading}
            onClick={() => context.setPageNumber(1)}
          >
            <CachedIcon />
          </Button>
          <Button
            disabled={loading}
            onClick={() => context.setFilter({})}
          >
            <CloseIcon />
          </Button>
        </ButtonGroup>

        <Drawer
          open={isOpen}
          onClose={this.handleClose}
          width={'450px'}
        >
          {this.props.children}
        </Drawer>
      </React.Fragment>
    )
  }
}
